import { useMemo } from 'react'
import { useDataSource } from '../../../../../lib/dataSource'
import { useLifeSpaceTasks } from '../../../hooks/useLifeSpaceTasks'
import { keepWhileParentListed, useListedChildren } from '../../../hooks/useListedChildren'
import type { ListedTask } from '../../../utils/taskToEntryData'

interface UseDormantTasksArgs {
  lifeSpace: 'personal' | 'work' | 'home'
  isActive: boolean
}


/**
 * Tasks with `pausedAt != null` scoped to the given life space (orphans via
 * `task.lifeSpace`, see {@link useLifeSpaceTasks}). **Erledigte kommen mit**
 * (`isDormantTask`) — sie liegen hinter dem **Geschafft-Schalter**. Sorted by
 * `pausedAt` desc so the most recently paused task is on top.
 *
 * **Unteraufgaben, die selbst ruhen** (#205), stehen mit dem Titel ihrer Aufgabe davor — nur
 * solange die Aufgabe offen und wach ist. Ruht die Aufgabe, steht nur sie da.
 */
export function useDormantTasks({ lifeSpace, isActive }: UseDormantTasksArgs): ListedTask[] | undefined {
  const tasks = useLifeSpaceTasks(lifeSpace, useDataSource().usePausedTasks(isActive))
  const listed = useListedChildren(tasks, keepWhileParentListed)
  return useMemo(() => {
    if (!listed) return undefined
    return [...listed].sort((a, b) => {
      const aMs = a.pausedAt ? a.pausedAt.getTime() : 0
      const bMs = b.pausedAt ? b.pausedAt.getTime() : 0
      return bMs - aMs
    })
  }, [listed])
}
